/* eslint-disable max-len */
import { Form } from '@sketchpixy/rubix';
import { Entity, ctx as L20NContext } from '@sketchpixy/rubix/lib/L20n';
import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import * as AreaActions from '../../../redux/actions/area.actions.js';
import * as GuestActions from '../../../redux/actions/guest.actions.js';
import WearableIconCustom from '../../CustomIcons/WearableIconCustom.jsx';
import FormFlatContainer from '../Elements/FormFlatContainer.jsx';
import CustomField from '../Fields/CustomField.jsx';
import MDCheckBoxField from '../Fields/MDCheckBox/MDCheckBoxField.js';
import SelectableField from '../Fields/SelectableInput/SelectableField.jsx';
import SentenceSelectorInputField from '../Fields/SentenceSelectorInputField.jsx';

const validate = values => {
  const errors = {};
  if (!values.deviceId) {
    errors.deviceId = 'required';
  } else if (_.trim(values.deviceId).length > 255) {
    errors.deviceId = 'maximumLenghtTwoHundredFiftyFive';
  }
  if (!values.userId) {
    errors.wearableUserSearch = 'required';
  }
  return errors;
};

@reduxForm({ form: 'WearableForm', validate, destroyOnUnmount: false })
@connect(state => ({
  users: state.guests.data.content,
}))
class WearableForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      guestsOptions: [],
      allowedAreasOptions: [],
      notAllowedAreasOptions: [],
    };
  }

  async onFilterGuests(value) {
    const { dispatch } = this.props;
    setTimeout(async () => {
      const guests = await dispatch(GuestActions.fetchUsersForSelector(value));
      const filterEmailGuests = _.uniqBy(_.filter(guests, guest => guest.email), 'email');
      const options = _.map(filterEmailGuests, guest => ({ value: guest, label: guest.email }));
      this.setState({ guestsOptions: options });
      return options;
    }, 800);
  }

  onSelectGuest(guest) {
    const { onSelectGuest } = this.props;
    if (guest) {
      if (onSelectGuest) onSelectGuest(guest);
    } else {
      if (onSelectGuest) onSelectGuest(null);
    }
  }

  async onFilterAllowedAreas(value) {
    const { dispatch } = this.props;
    setTimeout(async () => {
      const areas = await dispatch(AreaActions.fetchAreasForSelector(value));
      const options = _.map(areas, area => ({ value: area, label: area.name }));
      this.setState({ allowedAreasOptions: options });
      return options;
    }, 800);
  }

  onSelectAllowedAreas(areas) {
    const { onSelectAllowedAreas } = this.props;
    if (areas) {
      if (onSelectAllowedAreas) onSelectAllowedAreas(areas);
    } else {
      if (onSelectAllowedAreas) onSelectAllowedAreas(null);
    }
  }

  async onFilterNotAllowedAreas(value) {
    const { dispatch } = this.props;
    setTimeout(async () => {
      const areas = await dispatch(AreaActions.fetchAreasForSelector(value));
      const options = _.map(areas, area => ({ value: area, label: area.name }));
      this.setState({ notAllowedAreasOptions: options });
      return options;
    }, 800);
  }

  onSelectNotAllowedAreas(areas) {
    const { onSelectNotAllowedAreas } = this.props;
    if (areas) {
      if (onSelectNotAllowedAreas) onSelectNotAllowedAreas(areas);
    } else {
      if (onSelectNotAllowedAreas) onSelectNotAllowedAreas(null);
    }
  }

  render() {
    const { dispatch, wearableTypeOptions, selectedType } = this.props;
    const { guestsOptions, allowedAreasOptions, notAllowedAreasOptions } = this.state;
    const canManageWearables = true //AbilityProvider.getAbilityHelper().hasPermission([PERMISSIONS.ALL], PERMISSION_ENTITIES.WEARABLES_MANAGEMENT);
    
    return (
      <Form style={{ padding: 10 }}>
        <input style={{ display: 'none' }} type="username" name="username" />
        <FormFlatContainer
          title="wearableData"
          icon={<WearableIconCustom style={{ width: 22 }} />}
          containerStyle={{ marginRight: 10, marginTop: 5 }}
        >
          <Entity
            componentClass={Field}
            name="deviceId"
            componentAttribute="placeholder"
            entity="deviceId"
            title={<Entity entity="deviceId" />}
            component={CustomField}
            type="text"
            disabled={!canManageWearables}
            mandatory
          />
          <Field
            name="enableAsRfidCard"
            label={<Entity entity="enableAsRfidCard" />}
            titleStyle={{ fontSize: 16, color: '#3f3f3f' }}
            disabled={!canManageWearables}
            component={MDCheckBoxField}
            containerstyle={{ marginTop: 10 }}
          />
          <Field
            name="emergencyButtonEnabled"
            label={<Entity entity="emergencyButtonEnabled" />}
            titleStyle={{ fontSize: 16, color: '#3f3f3f' }}
            disabled={!canManageWearables}
            component={MDCheckBoxField}
            containerstyle={{ marginTop: 0 }}
          />
          <div style={{ marginTop: 10, marginBottom: 12 }}>
            <h5 style={{ fontWeight: 'bold', fontSize: 16, color: '#3f3f3f', margin: 0 }}>{<Entity entity="assignedUser" />}</h5>
            <h5 style={{ color: '#3f3f3f', margin: 0, marginTop: 8, fontWeight: 'lighter' }}><Entity entity="wearableUserDescription" /></h5>
          </div>
          <Field
            name="wearableUserSearch"
            component={SelectableField}
            noCache
            options={guestsOptions}
            placeholder={<Entity entity="guestNameSearch" />}
            style={{ marginTop: 10 }}
            onInputChange={value => this.onFilterGuests(value)}
            onSelect={tagData => this.onSelectGuest(tagData)}
          />
          <div style={{ marginTop: 20, marginBottom: 12 }}>
            <h5 style={{ fontWeight: 'bold', fontSize: 16, color: '#3f3f3f', margin: 0 }}>{<Entity entity="allowedAreas" />}</h5>
            <h5 style={{ color: '#3f3f3f', margin: 0, marginTop: 8, fontWeight: 'lighter' }}><Entity entity="allowedAreasDescription" /></h5>
          </div>
          <Field
            name="allowedAreasOptions"
            component={SelectableField}
            noCache
            multi
            options={allowedAreasOptions}
            placeholder={<Entity entity="searchAreas" />}
            style={{ marginTop: 10 }}
            onInputChange={value => this.onFilterAllowedAreas(value)}
            onSelect={areas => this.onSelectAllowedAreas(areas)}
          />
          <div style={{ marginTop: 10 }}>
            <Field
              id="secondsOutsideAllowedAreasForAlarm"
              name="secondsOutsideAllowedAreasForAlarm"
              component={SentenceSelectorInputField}
              sentence={L20NContext.getSync('secondsOutsideAllowedAreasForAlarmSentence')}
              unit={L20NContext.getSync('minutes')}
              titleStyle={{ fontSize: 16 }}
            />
          </div>
          <div style={{ marginTop: 20, marginBottom: 12 }}>
            <h5 style={{ fontWeight: 'bold', fontSize: 16, color: '#3f3f3f', margin: 0 }}>{<Entity entity="notAllowedAreas" />}</h5>
            <h5 style={{ color: '#3f3f3f', margin: 0, marginTop: 8, fontWeight: 'lighter' }}><Entity entity="notAllowedAreasDescription" /></h5>
          </div>
          <Field
            name="notAllowedAreasOptions"
            component={SelectableField}
            noCache
            multi
            options={notAllowedAreasOptions}
            placeholder={<Entity entity="searchAreas" />}
            style={{ marginTop: 10 }}
            onInputChange={value => this.onFilterNotAllowedAreas(value)}
            onSelect={areas => this.onSelectNotAllowedAreas(areas)}
          />
          <div style={{ marginTop: 10 }}>
            <Field
              id="secondsInsideNotAllowedAreasForAlarm"
              name="secondsInsideNotAllowedAreasForAlarm"
              component={SentenceSelectorInputField}
              sentence={L20NContext.getSync('secondsNotAllowedAreasForAlarmSentence')}
              unit={L20NContext.getSync('minutes')}
              titleStyle={{ fontSize: 16 }}
            />
          </div>
          {/* <Field
            name="userId"
            title=""
            component={MDAutoCompleteField}
            disabled={!canManageWearables}
            placeholder={<Entity entity="selectUser" />}
            loadOptions={inputValue => this.onLoadUserOptions(inputValue)}
            defaultOptions={this.onGetUserOptions()}
            isClearable
          /> */}
        </FormFlatContainer>
      </Form>
    );
  }
} 

export default WearableForm;
